/**
 * @desc 根据账号查询账号信息，状态非必填
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.FinanceAccountResponseDto>>;
export function request(
  body: defs.basics.AccountQueryRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paypalAccount/getByAccount`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
